import {
  APIReportFilters,
  DataSourceField,
  ReportColumn,
  ReportColumnType,
  WidgetGlobalFilterBindings,
} from '@ardoq/api-types';
import {
  ConflictType,
  WidgetCondition,
} from 'dashboard/DashboardBuilder/types';
import { isEmpty, omit } from 'lodash';

const apiFilterToCondition = (
  filter: APIReportFilters
): WidgetCondition | undefined => {
  const columnKey = Object.keys(filter)[0];
  return { columnKey, values: filter[columnKey]?.values ?? [] };
};

const conditionToAPIFilter = (
  condition: WidgetCondition
): APIReportFilters => ({
  [condition.columnKey]: { values: condition.values },
});

const getReportColumnType = (field: DataSourceField): ReportColumnType => {
  if (field.referenceTypeOutgoing)
    return ReportColumnType.REFERENCE_TYPE_OUTGOING;
  if (field.referenceTypeIncoming)
    return ReportColumnType.REFERENCE_TYPE_INCOMING;
  if (field.field) return ReportColumnType.FIELD;
  return ReportColumnType.CUSTOM;
};

const getConflictType = (
  columnKey: string,
  chartFilters: APIReportFilters | undefined,
  globalFilterBindings: WidgetGlobalFilterBindings | undefined
): ConflictType | undefined => {
  if (chartFilters && columnKey in chartFilters) return 'chartFilter';
  if (globalFilterBindings && columnKey in globalFilterBindings)
    return 'dashboardFilter';
  return undefined;
};

const removeReportColumnFromFilters = (
  chartFilters: APIReportFilters,
  key: string
): APIReportFilters | undefined => {
  const filtersWithoutKey = omit(chartFilters, key);
  return !isEmpty(filtersWithoutKey) ? filtersWithoutKey : undefined;
};

const dataSourceFieldToReportColumn = (
  field: DataSourceField
): ReportColumn => ({
  key: field.name,
  label: field.label,
  type: getReportColumnType(field),
  dataType: field.type,
  numberFormatOptions: field.numberFormatOptions,
});

export const conditionOperations = {
  apiFilterToCondition,
  conditionToAPIFilter,
  getConflictType,
  removeReportColumnFromFilters,
  dataSourceFieldToReportColumn,
};
